export const SCOUT_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export function getCooldownEnd(start: string | Date | null | undefined): Date | null {
  if (!start) return null;
  const d = typeof start === 'string' ? new Date(start) : start;
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getTime() + SCOUT_COOLDOWN_MS);
}

export function getRemainingMs(endsAt: string | Date | null | undefined): number {
  if (!endsAt) return 0;
  const d = typeof endsAt === 'string' ? new Date(endsAt) : endsAt;
  if (Number.isNaN(d.getTime())) return 0;
  return Math.max(0, d.getTime() - Date.now());
}

export function formatRemaining(ms: number): string {
  if (ms <= 0) return '';
  const totalSec = Math.ceil(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m`;
  return `${totalSec}s`;
}

export function isOnCooldown(endsAt: string | Date | null | undefined): boolean {
  return getRemainingMs(endsAt) > 0;
}